import{ useState } from "react";

function AssignmentEntry({assignment}) {
    const [showDesc, setShowDesc] = useState(false);
    return (

<div>
                            <p class="card-text pb-0 mb-0">{assignment.entry} {assignment.desc !== undefined && <a href="#" className="link-light" onClick={() => {setShowDesc(!showDesc)}}>{!showDesc ? "See details" : "Hide details"}</a>}</p>
                            {showDesc && <p class="card-text pb-0 mb-0" dangerouslySetInnerHTML={{__html:assignment.desc}}></p>}
                            </div> 
    )
}

export default AssignmentEntry;